import * as tslib_1 from "tslib";
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var BannersService = /** @class */ (function () {
    function BannersService(http) {
        this.http = http;
    }
    BannersService.prototype.list = function (filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get(environment.apiUrl + "/cms/banners" + filter).toPromise()];
            });
        });
    };
    BannersService.prototype.create = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.post(environment.apiUrl + "/cms/banner", body).toPromise()];
            });
        });
    };
    BannersService.prototype.update = function (id, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.put(environment.apiUrl + "/cms/banner/" + id, body).toPromise()];
            });
        });
    };
    BannersService.prototype.findOne = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get(environment.apiUrl + "/cms/banners/" + id).toPromise()];
            });
        });
    };
    BannersService.prototype.delete = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.delete(environment.apiUrl + "/cms/banner/" + id).toPromise()];
            });
        });
    };
    BannersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BannersService_Factory() { return new BannersService(i0.ɵɵinject(i1.HttpClient)); }, token: BannersService, providedIn: "root" });
    return BannersService;
}());
export { BannersService };
